var render = function render(){var _vm=this,_c=_vm._self._c;return _c('onsitetemplate-editor',{attrs:{"init_id":this.$route.params.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }